import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AddCustomersForm from "./AddCustomersForm";

const AddCustomersFormDynamicPage = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    navigate("/customers");
  };

  return (
    <AddCustomersForm
      open={open}
      onClose={handleClose}
      useDynamicForm
    />
  );
};

export default AddCustomersFormDynamicPage;
